// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "._3NfwvY2_FTiuEjlQO57mOE {\n  position: absolute;\n  width: 200;\n  height: 200;\n  font: 14px sans-serif;\n  pointer-events: none;\n}\n\n._1Y8roTGiOfgBXVniCXbjG5 {\n  position: absolute;\n  width: 200;\n  height: 200;\n  font: 14px sans-serif;\n  pointer-events: none;\n}\n", "",{"version":3,"sources":["Chopsticks.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;AACF","file":"Chopsticks.css","sourcesContent":[".tooltip {\n  position: absolute;\n  width: 200;\n  height: 200;\n  font: 14px sans-serif;\n  pointer-events: none;\n}\n\n.legend {\n  position: absolute;\n  width: 200;\n  height: 200;\n  font: 14px sans-serif;\n  pointer-events: none;\n}\n"]}]);
// Exports
exports.locals = {
	"tooltip": "_3NfwvY2_FTiuEjlQO57mOE",
	"legend": "_1Y8roTGiOfgBXVniCXbjG5"
};
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader/dist/cjs.js??ref--1-1!../node_modules/postcss-loader??ref--1-2!./components/Chopsticks/Chopsticks.css
// module id = 537
// module chunks = 37